import LocomotiveScroll from 'locomotive-scroll'
import { module } from 'modujs'

export default class extends module {
  init() {
    this.scroll = new LocomotiveScroll({
      modularInstance: this,
      autoStart: false
      // lenisOptions: {
      //     syncTouch: true,
      //     touchInertiaMultiplier: 14
      // }
    })

    // Force scroll to top
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual'
      window.scrollTo(0, 0)
    }

    this.initScrollToElements()

    this.start = this.start.bind(this)
    this.stop = this.stop.bind(this)
    this.resize = this.resize.bind(this)

    window.addEventListener('scroll-start', this.start)
    window.addEventListener('scroll-stop', this.stop)
    window.addEventListener('scroll-resize', this.resize)
  }

  start() {
    this.scroll.start()
  }

  stop() {
    this.scroll.stop()
  }

  resize() {
    this.scroll.resize()
  }

  scrollTo(target, delay = 0) {
    setTimeout(() => {
      this.scroll?.scrollTo(target, {
        duration: 1,
        lerp: 0.1,
        lock: false
        // easing: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x)
      })
    }, delay)
  }

  scrollToExternal(target) {
    this.scrollTo(target)
  }

  initScrollToElements() {
    this.el.querySelectorAll('[data-scroll-to]').forEach((elt) => {
      elt.$callback = (e) => {
        e.preventDefault()

        const target = document.querySelector(`[data-scroll-target="${elt.getAttribute('data-scroll-to')}"]`)
        const delay = elt.getAttribute('data-scroll-to-delay')
          ? Number.parseInt(elt.getAttribute('data-scroll-to-delay'))
          : 0

        if (target) {
          this.scrollTo(target, delay)
        }
      }

      elt.addEventListener('click', elt.$callback)
    })
  }

  scrollTop(force) {
    if (!this.scroll)
      return
    if (force) {
      this.scroll.scrollTo('top', { immediate: true })
    }
    else {
      scrollTo('top')
    }
  }

  destroy() {
    window.removeEventListener('scroll-start', this.start)
    window.removeEventListener('scroll-stop', this.stop)
    window.removeEventListener('scroll-resize', this.resize)

    this.el.querySelectorAll('[data-scroll-to]').forEach((elt) => {
      elt.removeEventListener('click', elt.$callback)
      elt.$callback = undefined
    })

    this.scroll.destroy()
  }
}
